import axios from "axios";
import {addToCartHandler} from "./addToCart";

const cart = document.querySelector('.js-cart');
const donationSelect = document.querySelector('#cart-donation');

if(cart) {
    const freeProducts = [...cart.querySelectorAll('.js-cart-free-product')];
    const upsells = [...cart.querySelectorAll('.js-cart-add-upsell')];

    freeProducts.map((freeProduct) => {
        const freeProductAddToCartForm = freeProduct.querySelector('form');

        freeProductAddToCartForm.addEventListener('submit', (e) => {
            addToCartHandler(e, 1, false);
        });

        freeProductAddToCartForm.submit();
    });

    upsells.map((upsell) => {
        upsell.addEventListener('click', (e) => {
            upsell.querySelector('.btn').classList.add('disabled');
            addToCartHandler(e, 1, true);
        });
    });
}

if (donationSelect) {
    donationSelect.addEventListener('change', function() {
        const variantId = this.value;
        
        if (variantId) {
            fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'Accept': 'application/json'
                },
                body: JSON.stringify({ id: variantId, quantity: 1 })
            })
            .then(response => {
                if (response.ok) {
                    return response.json();
                }
            })
            .then(() => {
                location.reload();
            })
            .catch(error => {
                console.error('Error adding donation to cart:', error);
            });
        }
    });
}

export const updateCart = async (id, quantity) => {
    let response = await axios.post(`${window.Shopify.routes.root}cart/update.js`, {updates: {[id]: quantity}});
    document.body.style.opacity = .3;

    if(response.status === 200) {
        location.reload();
    }
}
